import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'

@jsonClass('ScreenOutput')
export class ScreenOutput {
	@jsonProperty(String)
	name: string
	@jsonProperty(String)
	outputTsType: string
	@jsonProperty(Boolean)
	canDriveProcess: boolean = false

	constructor(init: ScreenOutput) {
		assignCommonProperties(this, init)
	}
}
